<template>
	<Slides :slides="slides" class="top-content" />
</template>

<script>
import Slides from './Slides.vue'

export default {
	name: 'SlidesLocations',
	components: {
		Slides,
	},
	data: () => ({
		slides: [
			{
				body: ``,
				background: 'slides/photos/1.jpg',
			},
			{
				background: 'slides/photos/2.jpg',
			},
			{
				background: 'slides/photos/3.jpg',
			},
			{
				background: 'slides/photos/4.jpg',
			},
			{
				background: 'slides/photos/5.jpg',
			},
			{
				background: 'slides/photos/6.jpg',
			},
			{
				background: 'slides/photos/7.jpg',
			},
			{
				background: 'slides/photos/8.jpg',
			},
			{
				background: 'slides/photos/9.jpg',
			},
			{
				background: 'slides/photos/10.jpg',
			},
			{
				background: 'slides/photos/11.jpg',
			},
		]
	})
}
</script>

<style scoped lang="scss">
</style>
